// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o9RT","newExpiryDate":"styles_newExpiryDate__1c07W","footer":"styles_footer__3iugY"};